export const INIT_SENDBIRD = 'INIT_SENDBIRD'
export const RESET_MESSAGES = 'RESET_MESSAGES';
export const RESET_CHAT_MESSAGES = 'RESET_CHAT_MESSAGES';
export const SET_LOADED_MESSAGES = 'SET_LOADED_MESSAGES';
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_ATTACHMENT_MESSAGE = 'ADD_ATTACHMENT_MESSAGE';
export const SET_TYPING = 'SET_TYPING';
export const SET_MESSAGECOUNTS = 'SET_MESSAGECOUNTS';
export const RESET_CHANNELS = 'RESET_CHANNELS';
export const SET_CHANNELS = 'SET_CHANNELS';
export const SET_TOKEN = 'SET_TOKEN'

export const GLOBAL_HANDLER = 'GLOBAL_HANDLER';
export const MAX_COUNT = '9+';
export const GET_MESSAGE_LIMIT = 20;
export const SET_CHAT_HISTORY = 'SET_CHAT_HISTORY';
export const ADD_HISTORY_MESSAGES = 'ADD_HISTORY_MESSAGES';
export const ADD_LIVE_MESSAGE = 'ADD_LIVE_MESSAGE';
export const RESET_CHAT = 'RESET_CHAT';
export const SET_RECENT_MESSAGES = 'SET_RECENT_MESSAGES';
export const SET_RECENT_MESSAGES_REPLACE = 'SET_RECENT_MESSAGES_REPLACE';
